module.exports = __webpack_public_path__ + "static/img/pta_2019.ce64aff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pta_2019.jpg
// module id = aCXv
// module chunks = 2